import { Component, OnInit } from '@angular/core';
import { GeneralService } from '@app/core/http';
import { IResPay } from '@app/core/http/general/general.interface';
import { AlertService } from 'ngx-venus';

@Component({
  selector: 'app-pix-result',
  templateUrl: './pix.component.html',
  styleUrls: ['./pix.component.css'],
})
export class PixResultComponent implements OnInit {
  constructor(
    private generalService: GeneralService,
    public alertService: AlertService
  ) {}

  paymentResult: IResPay | any = null;

  pixUrl: string = '';
  ngOnInit(): void {
   const result = localStorage.getItem('payment-result') || '';

    if (result) {
      this.paymentResult = JSON.parse(result);
    }

  this.pixUrl = this.pixImageSrc(this.paymentResult?.extra?.pixUrl);
  }

pixImageSrc(pixUrl: string): string {
  if (!pixUrl) return ''; 

  // if it is already a URL, return it
  if (pixUrl.startsWith('http://') || pixUrl.startsWith('https://')) {
    return pixUrl;
  }

  // if it is a base64 image, return it
  if (pixUrl.startsWith('data:image/')) {
    return pixUrl;
  }

  // if it is a base64 image without data:image/, format it
  return `data:image/png;base64,${pixUrl}`;
}
  
  backToMerchant() {
    this.generalService.backToMerchant();
  }
}
